import { render } from "./CustomizeColumnsModal.vue?vue&type=template&id=95f6d8f0&scoped=true&ts=true&lang=pug"
import script from "./CustomizeColumnsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomizeColumnsModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomizeColumnsModal.vue?vue&type=style&index=0&id=95f6d8f0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f6d8f0"]])

export default __exports__